//
// Memoized version of groupBy. See: lib/groupBy.jsx
//
export const useGroupBy = (xs, keyFn) => React.useMemo(() => groupBy(xs, keyFn), [xs, keyFn])
